"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vectorValueNumberBinaryOperator = exports.vectorValueBinaryOperator = exports.numberValueBinaryOperator = void 0;
const exception_1 = require("../exception");
const number_1 = require("../number");
const unit_1 = require("../unit");
const value_1 = require("../value");
const numberValueBinaryOperator = (a, b, method) => {
    var _a;
    (0, number_1.unitCheck)(a, b);
    return (0, number_1.unitConversion)(method.call((0, number_1.toBaseUnit)(a), (0, number_1.toBaseUnit)(b)), (0, unit_1.getBaseUnitOf)((_a = a.unit) === null || _a === void 0 ? void 0 : _a.type));
};
exports.numberValueBinaryOperator = numberValueBinaryOperator;
const vectorValueBinaryOperator = (a, b, callback) => {
    if (a.elements.length !== b.elements.length) {
        throw new exception_1.RangeError("Vector length mismatch.");
    }
    return (0, value_1.newVectorValue)(a.elements.map((value, index) => callback(value, b.elements[index])));
};
exports.vectorValueBinaryOperator = vectorValueBinaryOperator;
const vectorValueNumberBinaryOperator = (a, b, callback) => (0, value_1.newVectorValue)(a.elements.map((value) => callback(value, b)));
exports.vectorValueNumberBinaryOperator = vectorValueNumberBinaryOperator;
